import React from 'react';

const PDFViewer = ({ pdfUrl, title = "Document PDF" }) => {
  console.log('PDFViewer received URL:', pdfUrl);
  
  if (!pdfUrl) {
    return (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center', 
        backgroundColor: '#f9f9f9',
        border: '1px solid #ddd',
        borderRadius: '8px'
      }}>
        <p>PDF is being generated...</p>
      </div>
    );
  }

  return (
    <div style={{ marginBottom: '32px' }}>
      {/* Simple iframe without container styling */}
      <iframe
        src={pdfUrl}
        width="100%"
        height="800px"
        title="PDF Document"
        style={{ 
          border: "1px solid #ccc",
          borderRadius: '4px'
        }}
        onLoad={() => console.log('PDF iframe loaded successfully')}
        onError={(e) => {
          console.log('Iframe failed to load PDF:', e);
        }}
      />
    </div>
  );
};

export default PDFViewer; 